import _ from "lodash";
export default (state: [] = [], action: any) => {
	switch (action.type) {
		case "GET_COMPANY_SUCCESS":
			return _.unionBy([action.resource], state, "id");
		case "GET_COMPANIES_SUCCESS":
			return _.unionBy(action.resource as tcpinpoint.Company[], state, "id");
		case "CLEAR_SESSION":
			return [];
		default:
			return state;
	}
};
